import React from "react";
import { getImageUrl } from "../../../utils/imageUrl";
import { PermissionWrapper } from "../../PermissionWrapper/PermissionWrapper";

interface RoleTableActionsProps {
  onView?: () => void;
  onEdit?: () => void;
}

const RoleTableActions: React.FC<RoleTableActionsProps> = ({
  onView,
  onEdit,
}) => {
  return (
    <div className="user-table-actions">
      <div className="user-table-actions-icons">
        <button
          type="button"
          className="user-table-action-btn"
          title="View"
          onClick={onView}
        >
          <img
            src={getImageUrl("shared/assets/icons/eye_outlined.svg")}
            alt="View"
            onError={(e) => {
              const target = e.target as HTMLImageElement;
              target.style.display = "none";
              const fallback = document.createElement("i");
              fallback.className = "ph-eye";
              target.parentElement?.appendChild(fallback);
            }}
          />
        </button>
        <PermissionWrapper
          anyOfPermissions={[
            "access_management.admin",
            "access_management.roles.manage",
          ]}
          hideWhenDisabled
        >
          <button
            type="button"
            className="user-table-action-btn"
            title="Edit"
            onClick={onEdit}
          >
            <img
              src={getImageUrl("shared/assets/icons/edit-outlined.svg")}
              alt="Edit"
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.style.display = "none";
                const fallback = document.createElement("i");
                fallback.className = "ph-pencil-simple";
                target.parentElement?.appendChild(fallback);
              }}
            />
          </button>
        </PermissionWrapper>
      </div>
    </div>
  );
};

export default RoleTableActions;
